import { render } from "./BackArrow.vue?vue&type=template&id=0ee52ae5"
const script = {}
script.render = render

export default script